package com.eladfinish.bible.contest.screens.lexicographicalSort.usecases

import com.eladfinish.bible.contest.network.ApiBaseUrlProvider
import com.eladfinish.bible.contest.network.isNetworkConnectivityError
import com.eladfinish.contract.email.SendHtmlEmailRequest
import com.eladfinish.contract.email.SendHtmlEmailResponse
import io.github.aakira.napier.Napier
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.plugins.timeout
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType

interface SendHtmlEmailUseCase {
    suspend operator fun invoke(request: SendHtmlEmailRequest): Result<Unit>
}

class SendHtmlEmailUseCaseImpl(
    private val httpClient: HttpClient,
    private val apiBaseUrlProvider: ApiBaseUrlProvider,
) : SendHtmlEmailUseCase {

    override suspend fun invoke(request: SendHtmlEmailRequest): Result<Unit> {
        Napier.d(
            message = "send_html_email: htmlSize=${request.tableHtml.length}, mikudChapters=${request.mikudChapterNumbers}",
            tag = "SendHtmlEmailUseCase",
        )

        return runCatching {
            val response = httpClient.post(
                urlString = "${apiBaseUrlProvider.getBaseUrl()}/email/send-pdf-from-html",
            ) {
                timeout {
                    requestTimeoutMillis = 180_000L
                    socketTimeoutMillis = 180_000L
                    connectTimeoutMillis = 10_000L
                }
                contentType(ContentType.Application.Json)
                setBody(request)
            }.body<SendHtmlEmailResponse>()

            if (!response.success) {
                error(response.errorMessage ?: "Failed to send email")
            }
        }.fold(
            onSuccess = { Result.success(Unit) },
            onFailure = { e ->
                if (e.isNetworkConnectivityError()) {
                    Napier.w(message = "send_html_email: no internet", throwable = e, tag = "SendHtmlEmailUseCase")
                    Result.failure(Exception("אין חיבור לאינטרנט. נסו שוב כשיהיה חיבור."))
                } else {
                    Napier.e(message = "send_html_email: unexpected error", throwable = e, tag = "SendHtmlEmailUseCase")
                    Result.failure(e)
                }
            },
        )
    }
}
